import GoalPauseReleaseDialog from './GoalPauseReleaseDialog';

export default GoalPauseReleaseDialog;
